import { Directive, ElementRef, HostListener, Input, Optional } from '@angular/core';

import { InputComponent } from '../input/input.component';
import { OverlayChildDirective } from './dropdown-child.directive';

@Directive({
  selector: '[dpwAnchor]',
  exportAs: 'dpwAnchor',
})
export class AnchorDirective {
  @Input()
  anchorEnabled = true;

  @Input()
  delay = 0;

  get element(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  constructor(
    public elementRef: ElementRef<HTMLElement>,
    @Optional() public input?: InputComponent,
    @Optional() private overlayChild?: OverlayChildDirective,
  ) {}

  @HostListener('mousedown')
  onMousedown(): void {
    if (this.overlayChild) {
      this.overlayChild?.parent?.forceStopClose();
    }
  }
}
